import { render, staticRenderFns } from "./StudyGuide.vue?vue&type=template&id=96cd1cca"
import script from "./StudyGuide.vue?vue&type=script&lang=js"
export * from "./StudyGuide.vue?vue&type=script&lang=js"
import style0 from "./StudyGuide.vue?vue&type=style&index=0&id=96cd1cca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports